import { useEffect } from 'react';
import { useRouterContext } from '../../lib/router';

export const useBackButton = (): void => {
  const { setMetadata } = useRouterContext();
  useEffect(() => {
    setMetadata((prev) => ({
      ...prev,
      showBackButton: true,
    }));
    return () =>
      setMetadata((prev) => ({
        ...prev,
        showBackButton: false,
      }));
  }, [setMetadata]);
};
